import { hexToHsva, hsvaToHexa } from '@meitu/saas-colors';
import { translateLongSide, translateXYToAngle } from '@meitu/saas-editor-core/es/utils/math-kit';

const toFixed = (num: number) => {
    // 保留两位小数四舍五入取整
    return Math.round((num || 0) * 100);
};

// 判断颜色字符串最后两位是不是00
export const isColorLastTwoZero = (str: string) => {
    return str?.slice(-2) === '00';
};

export const getColorAlpha = (color: string) => {
    return isColorLastTwoZero(color) ? 0 : toFixed(hexToHsva(color || '#000').a);
};

export const transferColorOpacity = (oldColor: string, alpha: number) => {
    const hsva = hexToHsva(oldColor);
    hsva.a = alpha / 100;
    const color = hsvaToHexa(hsva);
    return color;
};

export const transferXYToAngle = (x: number, y: number) => {
    if (x === 0 && y === 0) {
        return 0;
    }
    let angle = translateXYToAngle(x, y);

    return (angle = +angle.toFixed(1));
};

export const transferXYToDistance = (x: number, y: number) => {
    let distance = translateLongSide(x, y);
    distance = +distance.toFixed(1);
    return distance;
};
